import { useState } from 'react'
import { services } from '../../utils/constants'
import { BackToTop, Footer, FormElement, HeadingBox, Nav, NormalButton, PopupModal } from '../../components'
const Request = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [company, setCompany] = useState('');
  const [selectedServices, setSelectedServices] = useState([]);
  const [message, setMessage] = useState('');
  const [serviceDetails, setServiceDetails] = useState({});
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const classes = "form-control w-full px-3 py-1.5 text-gray-700 rounded border border-solid border-gray-300 focus:border-pink-600 focus:outline-none"


  const handleServiceSelection = (e) => {
    const serviceName = e.target.value;
    if(e.target.checked){
      const newSelectedServices = [...selectedServices, serviceName];
      setSelectedServices(newSelectedServices);
    }else{
      const newSelectedServices = selectedServices.filter(
        (service) => service !== serviceName
      );
      setSelectedServices(newSelectedServices);      
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    const formData = {
      name,
      email,
      phone,
      company,
      message,
      services: selectedServices.map((service) => ({
        name: service,
      })),
    };
    console.log(formData)
    // try {
    //   const response = await fetch("/api/request", {
    //     method: "POST",
    //     headers:{
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(formData)
    //   })
    //   if(response.ok){
    //     setShowModal(true);
    //     setLoading(false)
    //     // Reset the form
    //     setName('');
    //     setEmail('');
    //     setPhone('');
    //     setCompany('');
    //     setMessage('');
    //     setSelectedServices([]);
    //   }   
    // } catch (error) {
    //   console.error("Error sending email", error);
    //   setLoading(false)
    // }
      
  }

  const handleCloseModal = () => {
    setShowModal(false);
  }
  return (
    <>
    <Nav />
    <main>
      <section className='px-10 py-20 flex gap-5 flex-col'>
        <div className='flex flex-col gap-4'>
            <div className='w-[28px] h-[28px] bg-custom-yellow'></div>
            <HeadingBox 
              title="Request Form"
              desc="Fill up the form and our team will get back to you within 24hrs"
            />
        </div>
        <div>
          <form onSubmit={handleSubmit} action="" className='flex flex-col gap-5 p-4 border border-[#ECE7F1]'>
            <div className="form-group mb-6">
                <label className="block text-gray-700 text-sm font-bold mb-2">Name</label>
                <input 
                  className={classes} 
                  type="text"
                  id="name"
                  placeholder="Enter your name here...."
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            <div className="form-group mb-6">
                <label className="block text-gray-700 text-sm font-bold mb-2">Email</label>
                <input 
                  className={classes} 
                  type="text"
                  id="email"
                  placeholder="Enter your Email here...."
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            <div className="form-group mb-6">
                <label className="block text-gray-700 text-sm font-bold mb-2">Phone Number</label>
                <input 
                  className={classes} 
                  type="tel"
                  placeholder="Enter your Phone Number here...."
                  value={phone}
                  id="phone"
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
            <div className="form-group mb-6">
                <label className="block text-gray-700 text-sm font-bold mb-2">Company</label>
                <input 
                  className={classes} 
                  type="text"
                  id='company'
                  placeholder="Enter your Company Name here...."
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  required
                />
              </div>
            <div className="form-group mb-6">
                <label className="block text-gray-700 text-sm font-bold mb-2">Message</label>
                <textarea 
                  className={classes} 
                  type="text"
                  id='message'
                  placeholder="Enter your Message Name here...."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </div>
            <div className="form-group mb-6 flex flex-col gap-3">
              {
                selectedServices.length > 0 && <div className='bg-[#37006718] px-3 py-4 h-auto w-full flex items-center flex-row flex-wrap gap-3'>
                {
                      selectedServices.map((service) => (
                        <h3 className='bg-custom-bg p-2 rounded-lg text-white' key={service}>{service}</h3>
                      ))
                    }
          </div>
              }
              
                <label className="block text-gray-700 text-sm font-bold mb-2">Select Services</label>
                {
                  services.map((service) => (
                    <>
                    <div key={service.name} className=''>
                        <label htmlFor={service.name} className='flex flex-row gap-3'>
                        <input 
                          className="text-gray-700 rounded border border-solid border-gray-300 focus:border-pink-600 focus:outline-none"
                          type="checkbox"
                          id={service.name}
                          value={service.name}
                          checked={selectedServices.includes(service.name)}
                          onChange={handleServiceSelection}
                        />
                        <h6>
                          {service.name}
                        </h6>
                        </label>
                    </div>
                    </>
                  ))
                }
              </div>
              {
                loading ? <p className='bg-pink-300 p-2 text-black rounded-lg'>Loading.....</p> : <NormalButton title="Submit" type="submit" />

              }          </form>
           {
            showModal && (
              <PopupModal 
                message="Message sent succesfully"
                onClose={handleCloseModal}
                autoCloseDuration={5000}
              />
            )
          }
        </div>
      </section>
    </main>
    <BackToTop />
    <Footer />
    </>
  )
}

export default Request